import React, { useEffect, useState } from "react";
import { useGetLookupValuesMutation } from "../api/api";
import GenericDropdown from "./GenericDropDown";
import { LOOKUPS } from "../lib/constants";

interface ModeDropdownProps {
  selectedModeId: number | null;
  onModeChange: (modeId: number) => void;
  isDistanceRangApplicable: boolean;
  setShowAlertOnRouteChange: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModeDropdown: React.FC<ModeDropdownProps> = ({
  selectedModeId,
  onModeChange,
  isDistanceRangApplicable,
  setShowAlertOnRouteChange,
}) => {
  const [getLookupValues, { isLoading: modesLoading }] =
    useGetLookupValuesMutation();
  const [modes, setModes] = useState<any[]>([]);

  useEffect(() => {
    const fetchModes = async () => {
      try {
        const result = await getLookupValues({
          lookupIdDto: { lookupId: LOOKUPS.Mode },
        });
        if (result.data) {
          setModes(result.data.data);
        } else {
          console.warn("No data returned from API");
        }
      } catch (error) {
        console.error("Error fetching modes:", error);
      }
    };

    fetchModes();
  }, [getLookupValues]);

  return (
    <GenericDropdown
      key={selectedModeId}
      labelValue={
        selectedModeId
          ? modes.find((mode) => mode.id === selectedModeId)?.name || ""
          : ""
      }
      onChange={(value) => {
        onModeChange(parseInt(value, 10));
        setShowAlertOnRouteChange(true);
      }}
      options={
        modes
          .filter((mode) => isDistanceRangApplicable || mode.id !== 26)
          .map((mode) => ({
            value: mode.id.toString(),
            label: mode.name.toString(),
          })) || []
      }
      placeholder="Select a mode"
      className="text-customGrayText h-11 bg-grayBackgroundColor justify-center items-center w-full border-gray-300"
      showAllOption={false}
      error={false}
      dropdownMenuContentWidth="w-[38vw] "
    />
  );
};

export default ModeDropdown;
